module.exports = __webpack_public_path__ + "static/media/31.b8876ec0.JPG";